import React, { useEffect, useState } from 'react';

import { Card, Col, Divider, message, Row, Statistic } from 'antd';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { StatisticsService } from 'services/StatisticsService';
import { FETCH_ERROR } from 'constants/alerts';
import { thousandFormatter } from 'utils/forms/formatter';
import { SalesTable } from './SalesTable';

const PAGE_TITLE = 'Объем продаж';

function Sales() {
  useDocumentTitle(PAGE_TITLE);
  useHeaderChanger(PAGE_TITLE);

  const [loading, setLoading] = useState(false);
  const [commonStatistics, setCommonStatistics] = useState({});
  const [primaryStatistics, setPrimaryStatistics] = useState([]);
  const [secondaryStatistics, setSecondaryStatistics] = useState([]);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    setLoading(true);

    try {
      const { statistics, packages, business } =
        await StatisticsService.getSalesStatistics();

      setCommonStatistics(statistics);
      setPrimaryStatistics(packages);
      setSecondaryStatistics(business);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Row gutter={10} style={{ marginBottom: '20px' }}>
        <Col span={8}>
          <Card>
            <Statistic
              title="Активные клиенты"
              formatter={thousandFormatter}
              value={commonStatistics?.active_now}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Купили тарифы"
              formatter={thousandFormatter}
              value={commonStatistics?.bought_packages}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Купили услуги"
              formatter={thousandFormatter}
              value={commonStatistics?.bought_services}
            />
          </Card>
        </Col>
      </Row>

      <SalesTable
        firstColName="Payda"
        items={primaryStatistics}
        loading={loading}
      />

      <Divider />

      <SalesTable
        firstColName="Business API"
        items={secondaryStatistics}
        loading={loading}
      />
    </>
  );
}

export { Sales };
